export class BeneficiarySyncEntity {
  constructor() {
    this.id = null;
    this.name = null;
    this.associatedAccountID = null;
    this.nickname = null;
    this.sortCode = null;
    this.accountNumber = null;
    this.accountNoForDisplay = null;
    this.reference = null;
    this.posted = true;
    this.isSelected = false;
  }
}
export default BeneficiarySyncEntity;
